<template>
    <div>
        <carousel :items="1">
            <div v-for="(item, i) in reverseItems"
                 :key="i">
                <CrmSubscription :crm-subscription="item" @prolong="prolong"/>
            </div>
        </carousel>
    </div>
</template>

<script>

    import CrmSubscription from "./CrmSubscription";
    import carousel from 'vue-owl-carousel'

    export default {
        name: 'CrmSubscriptionsList',
        props: {
            crmSubscriptions: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {}
        },

        computed: {
            reverseItems() {
                return this.crmSubscriptions.slice().reverse();
            }
        },

        mounted() {

        },

        methods: {
            prolong() {
                this.$emit('prolong')
            }
        },

        components: {CrmSubscription, carousel}
    }
</script>
